export default "__VITE_ASSET__BauxL_ZS__"